import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		goodsItemsId:'',
		
		userInfo:{},
		curPetInfo:{},
		petWeight:0,
		
		saleList:[],
		saleTotal:{total:0,activity:0},
		remark:'',
		
		ximeiList:[],
		ximeiRemark:'',
		curDiscountCard:null,
		discountMoney:0,
	},
	getters: {
		
	},
	mutations: {
		set_goodsItemsId(state, obj) {
			state.goodsItemsId = obj;
		},
		set_userInfo(state, obj) {
			state.userInfo = obj;
		},
		set_curPetInfo(state, obj) {
			state.curPetInfo = obj;
		},
		set_petWeight(state, obj) {
			state.petWeight = obj;
		},
		set_curDiscountCard(state, obj) {
			state.curDiscountCard = obj;
		},
		set_saleList(state, obj) {
			state.saleList = obj;
		},
		set_saleTotal(state, obj) {
			state.saleTotal = obj;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
		set_ximeiRemark(state, obj) {
			state.ximeiRemark = obj;
		},
		set_discountMoney(state, params) {
			state.discountMoney = params;
		},
		set_ximeiList(state, list) {
			let totalMoney = 0;
			let activityMoney = 0;
			for(let i=0;i<list.length;i++){
				totalMoney = $public.jia(totalMoney,list[i].skuItem.originalPrice)
				activityMoney = $public.jia(activityMoney,list[i].skuItem.price)
			}
			state.saleTotal = {total:totalMoney, activity:activityMoney}
			state.curDiscountCard = null;
			state.discountMoney = 0;
			state.ximeiList = list;
		},
	},
	actions: {

	},
};
